import { ICreateReviewRequest, IRespondToReviewRequest, IReview } from '../interfaces/heavyDutyMachinery/IReview';
import { apiService } from './ApiService';
import { API_ENDPOINTS } from '../constants/apiEndpoints';
import { HTTP_METHODS } from '../constants/httpMethods';

const heavyDutyMachineryBaseUrl = process.env.REACT_APP_HEAVY_DUTY_MACHINERY_API_URL || '';

export const getReviewsForSpace = async (spaceId: string): Promise<IReview[]> => {
  const response = await apiService<IReview[]>({
    url: API_ENDPOINTS.HEAVY_DUTY_MACHINERY_REVIEWS_FOR_SPACE(spaceId),
    method: HTTP_METHODS.GET,
    baseUrl: heavyDutyMachineryBaseUrl,
  });
  if (response.success) return response.data;
  throw new Error(response.error || 'Failed to load reviews');
};

export const createReview = async (request: ICreateReviewRequest): Promise<IReview> => {
  const response = await apiService<IReview>({
    url: API_ENDPOINTS.HEAVY_DUTY_MACHINERY_REVIEWS,
    method: HTTP_METHODS.POST,
    body: { ...request },
    baseUrl: heavyDutyMachineryBaseUrl,
  });
  if (response.success) return response.data;
  throw new Error(response.error || 'Failed to submit review');
};

export const respondToReview = async (id: string, request: IRespondToReviewRequest): Promise<IReview> => {
  const response = await apiService<IReview>({
    url: API_ENDPOINTS.HEAVY_DUTY_MACHINERY_REVIEW_RESPOND(id),
    method: HTTP_METHODS.POST,
    body: { ...request },
    baseUrl: heavyDutyMachineryBaseUrl,
  });
  if (response.success) return response.data;
  throw new Error(response.error || 'Failed to submit response');
};
